module.exports = __webpack_public_path__ + "img/house-tree.ffd9afe1.svg";